import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { liveModel } from "../Stream/StreamDesktop";
import { Notify } from "../../based/Notify";
import { NOTIFY } from "../../based/Constants";
import ArtistServices from "../../based/services/ArtistServices"



function ModalAddStream({setIsModal,getLiveStream,setLoading}) {
    const [liveStream, setLiveStream] = useState(liveModel)
    const [errorMessage, setErrorMessage] = useState("")

    const isValidElement = (link)=>{
        if(link.startsWith("https://tiktok.com/") || link.startsWith("https://vt.tiktok.com/") || link.startsWith("https://fb.gg"))
            return true;
        return false;
      }
    
      const createLinkLive = async () => {
        if (!liveStream.url) {
          setErrorMessage("Vui lòng nhập link live stream");
        }else if(!isValidElement(liveStream.url)){
            let msg = `Link live stream không đúng (Ví dụ: 'https://vt.tiktok.com/abc123...')`
            setErrorMessage(msg);
        }else{
            setErrorMessage("")
            setLoading(true)
            let [err, data] = await ArtistServices.CreateOrUpdateLinkStream({ ...liveStream});
            if (!err && data == 1) {
                setIsModal(false);
                getLiveStream()
                setLoading(false);
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Tạo thành công");
            } else {
                if (data == -2) {
                    setLoading(false);
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Đã tồn tại");
                } else {
                    setLoading(false);
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Tạo thất bại");
                }
            }



        }
    }



    return ( 
        <StyleModal onClick={()=>{setIsModal(false)}}>
            <div className="modal-art" onClick={(e)=>{
                e.stopPropagation()
            }}>
                <div className="modal-art-header">
                    <h3>Tạo Livestream mới</h3>
                    <div className="close-art" onClick={()=>{setIsModal(false)}}>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1L1 14" stroke="white" stroke-width="2" stroke-linecap="round"/>
                            <path d="M14 14L1 0.999999" stroke="white" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </div>
                </div>
                <div className="modal-art-body">
                    <textarea rows={6} placeholder="Sao chép liên kết link livestream dán vào đây" onChange={(e)=>{
                        setLiveStream({ ...liveStream , url: e.target.value})
                    }}></textarea>
                    {errorMessage && <span className="error">{errorMessage}</span>}
                    <button onClick={()=>{
                        createLinkLive();
                    }}>Bắt đầu livestream</button>
                </div>
            </div>
        </StyleModal>
    );
}

const StyleModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0,0,0,0.3);
    display: grid;
    place-items: center;


    .modal-art{
        width: 85%;
        background-color: #313131;
        border-radius: 10px;
        padding: 20px;

        .modal-art-header{
            display: flex;
            align-items: center;
            justify-content: space-between;

            h3{
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: -0.3px;
                color: #FFFFFF;
            }
            .close-art{
                cursor: pointer;
            }
        }


        .modal-art-body{
            margin-top: 20px;

            .error{
                color: red;
            }

            textarea{
                width: 100%;
                border-radius: 5px;
                padding: 8px 10px;
                background: #464646;
                color: #fff;

                ::placeholder{
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 18px;
                    letter-spacing: -0.3px;
                    color: #FFFFFF;
                    opacity: 0.2;
                }
            }

            button{
                width: 100%;
                border: none;
                outline: none;
                background: linear-gradient(259.14deg, #06F1B9 1.32%, #008263 100%);
                border-radius: 10px;
                height: 46px;
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: -0.3px;
                color: #FFFFFF;
                display: grid;
                place-items: center;
                margin-top: 12px;
            }
        }
    }


`
export default ModalAddStream;


// WEBPACK FOOTER //
// ./src/artist-ui/components/ModalAddStream.js